import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fullScreen",
  "use": "icon-fullScreen-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-fullScreen\"><defs><style>#icon-fullScreen .cls-1{fill:#231815;}</style></defs><title>全屏</title><path class=\"cls-1\" d=\"M6.06,12.67,1.8,16.93v-2a.9.9,0,0,0-1.8,0v4.2H0A.9.9,0,0,0,.89,20H5.1a.9.9,0,1,0,0-1.8h-2l4.26-4.26a.9.9,0,0,0-1.27-1.27Z\" /><path class=\"cls-1\" d=\"M3.07,1.8h2A.9.9,0,1,0,5.1,0H.9A.9.9,0,0,0,0,.89H0V5.1a.9.9,0,1,0,1.8,0v-2L6.06,7.33A.9.9,0,0,0,7.33,6.06Z\" /><path class=\"cls-1\" d=\"M19.93.56A.9.9,0,0,0,19.1,0H14.9a.9.9,0,1,0,0,1.8h2L12.67,6.06a.9.9,0,1,0,1.27,1.27L18.2,3.07v2a.9.9,0,1,0,1.8,0V.9A.9.9,0,0,0,19.93.56Z\" /><path class=\"cls-1\" d=\"M19.1,14a.9.9,0,0,0-.9.9v2l-4.26-4.26a.9.9,0,1,0-1.27,1.27l4.26,4.26h-2a.9.9,0,1,0,0,1.8h4.21a.9.9,0,0,0,.89-.9V14.9A.9.9,0,0,0,19.1,14Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fullScreen.svg
// module id = EmTC
// module chunks = 54